export const convertTo24Hour = (time) => {
    const regex = /^(0?[1-9]|1[0-2]):([0-5][0-9])\s?(AM|PM)$/i
    if (!regex.test(time)) return

    const [hours, minutes, period] = time.match(regex).slice(1)
    let hours24 = parseInt(hours)
    if (period.toUpperCase() === 'PM' && hours24 !== 12) {
        hours24 += 12
    } else if (period.toUpperCase() === 'AM' && hours24 === 12) {
        hours24 = 0
    }
    return {
        hours: `${hours24}`?.length > 1 ? hours24 : `0${hours24}`,
        minutes: minutes?.length > 1 ? minutes : '00'
    }
}

export const formatDate = (formatDateValues) => {
    const {date, ...rest} = formatDateValues
    return new Intl.DateTimeFormat('en-CA', {
        ...rest,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZoneName: 'long'
    })
        .formatToParts(date)
        .reduce((acc, parte) => {
            if (parte.type !== 'literal') acc[parte.type] = parte.value
            return acc
        }, {})
}

export const prepareDateToBooxi = ({date, timeZone = 'UTC'}) => {
    const {year, month, day, hour, minute, second} = formatDate({
        date,
        timeZone
    })

    return `${year}-${month}-${day}T${hour}:${minute}:${second}.00Z`
}

export const prepareDateToShow = (_date) => {
    const date = new Date(_date)
    const month = new Intl.DateTimeFormat('en-US', {month: 'long'}).format(date)
    const {day, hour, minute} = formatDate({
        date
    }) // Extract month

    return `${month}, ${day} - ${hour}:${minute}`
}
